import React, { useCallback, useEffect, useState } from 'react';
import { SDescription, SResendCode, SSmsCodeForm, SSubTitle, STitle } from './SmsCodePage.styles';
import { useLocation, useNavigate } from 'react-router-dom';
import { CustomButton } from 'components/CustomButton/CustomButton';
import { ROUTES } from 'constants/routes';
import { useSelector } from 'react-redux';
import { selectForgotPasswordData } from 'store/forgotPassword/forgotPassword.slice';
import { ISmsCodeMutationResult } from 'types/smsCode.types';
import { getResultData } from './helpers';
import { useCheckCodeMutation, useGenerateCodeMutation } from 'store/forgotPassword/forgotPassword.api';
import { getFingerPrint } from 'utils/webID';
import { getClientDateTime } from '../../utils/common';

export const SmsCodePage: React.FC = () => {
  const location = useLocation();
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);
  const [smsCode, setSmsCode] = useState('');
  const navigate = useNavigate();

  const { transactionId } = useSelector(selectForgotPasswordData);
  const [generateCode, generateResult] = useGenerateCodeMutation();
  const [checkCode, checkResult] = useCheckCodeMutation();

  const fingerprint = getFingerPrint(true) as string;
  const codeDelivery = location?.state?.codeDelivery || 'Email';

  const generateStatus = getResultData(generateResult as ISmsCodeMutationResult);
  const checkStatus = getResultData(checkResult as ISmsCodeMutationResult);

  const handleSubmitCode = () => {
    checkCode({
      code: smsCode,
      fingerprint,
      transactionId,
      clientDateTime: getClientDateTime(),
    });
  };

  const handleCompletion = (code: string) => {
    setSmsCode(code);
  };

  const handleResendCode = useCallback(() => {
    generateCode({
      codeDelivery,
      fingerprint,
      transactionId,
      clientDateTime: getClientDateTime(),
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (checkStatus?.isSuccess) {
      navigate(ROUTES.changePassword.path);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [checkStatus?.isSuccess]);

  useEffect(() => {
    handleResendCode();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <STitle>Verification</STitle>
      <SSubTitle>Enter the verification code</SSubTitle>

      <SSmsCodeForm handleCompletion={handleCompletion} onCompletion={setIsSubmitDisabled} checkError={checkStatus?.errorMessage} generateError={generateStatus?.errorMessage} />

      <CustomButton type="primary" block buttonSize="large" htmlType="submit" onClick={handleSubmitCode} disabled={isSubmitDisabled} marginBottom={52}>
        {isSubmitDisabled ? 'Continue' : 'Verify'}
      </CustomButton>

      <SDescription>Didn&apos;t receive verification code?</SDescription>
      <SResendCode onClick={handleResendCode}>Resend Code</SResendCode>
    </>
  );
}; 